<template>
  <div class="logWordChart-wrapper">
    <el-row type="flex" class="treeButton">
      <el-row class="mr-r15">
        <el-col :span="16">
          <div class="setting-addel">
            <el-button size="mini" @click="onZoom('zoomIn')"><i class="far fa-search-plus" style="font-size:14px;"></i></el-button>
            <el-button size="mini" @click="onZoom('zoomOut')"><i class="far fa-search-minus" style="font-size:14px;"></i></el-button>
          </div>
        </el-col>
        <el-col :span="8"><el-button @click="onZoom('zoomInit')" style="margin-left: 2px"><i class="far fa-sync-alt"></i></el-button></el-col>
      </el-row>
      <el-row class="vertical-center-box mr-r15 keywordPopOver">
        <el-popover placement="bottom" width="500" trigger="hover" :offset="40">
          <span class="text"> - 메시지의 구조를 파악하는 기능입니다. <br/> - 키워드 맵은 <em>최근 10000개의 로그</em>를 기준으로 작성됩니다</span>
          <span slot="reference"><i class="fas fa-info-circle" style="cursor: pointer"></i></span>
        </el-popover>
      </el-row>
    </el-row>
    <el-row class="vertical-center-box keywordSearchInput">
      <w-search-field class="mr-b15" @search="searchWord"/>
    </el-row>
    <div v-loading="loading" :style="renderLayer" class="render">
      <svg  ref="svg" class="svgclass" width="100%" height="93%"></svg>
      <el-row>
        <w-log-keyword-time-slider @dragTimeRangeChart="dragTimeRangeChart" :timeOption="timeOption" :active="active"></w-log-keyword-time-slider>
      </el-row>
      <div v-show="!regexFlag" class="no_map_box">
        <p class="no_map_title"><label>선택한 필드가 없습니다.</label></p>
        <p class="no_map_desc"><label>필드 명을 선택하세요.</label></p>
      </div>
      <div :class="svgToolTipName"></div>
    </div>
    <w-log-key-word-popup ref="keywordPopup" :search="search" :timeOption="timeOption" :selectNode="selectNode"></w-log-key-word-popup>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import msgUtil from '@/utils/message';
import * as d3 from 'd3';
import { isEmpty, isNil, forEach } from 'lodash';

import LmsLogAPI from '@/api/log/integrated-log';
import WSearchField from '@/components/form/SearchField';
import WLogKeywordTimeSlider from './LogKeywordTimeSlider';
import WLogKeyWordPopup from '../popup/LogKeywordPopup';

export default {
  name: 'WLogKeywordMap',
  components: {
    WLogKeywordTimeSlider,
    WSearchField,
    WLogKeyWordPopup,
  },
  data() {
    return {
      selectNode: {},
      svgToolTipName: 'tooltip',
      timeOption: {
        selectStep: 0,
        interval: 0,
      },
      search: '',
      checkGroupFlag: false,
      loading: false,
      chartData: null,
      regex: null,
      regexFlag: false,
      link: [],
      node: [],
      wordArrayData: [],
      textElements: {},
      graphLayout: {},
      wordChartData: [],
      adjlist: [],
      zoomHandler: null,
      zoom: {
        x: 0,
        y: 0,
        k: 1,
      },
      g: null,
    };
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['selectedNode', 'analysisDateParams']),
    renderLayer() {
      if (this.regexFlag) {
        return { height: '100%', width: '100%' };
      }
      return { height: '100%', width: '100%', position: 'relative' };
    },
    svgToolTip() {
      return this.$el && d3.select(this.$el).select(`div[class="${this.svgToolTipName}"]`);
    },
  },
  watch: {
    selectedNode() {
      if (this.active) {
        this.regex = null;
        this.regexFlag = false;
        this.checkGroupFlag = false;
        this.chartReset();
      }
    },
    active: {
      handler(to) {
        if (!to) {
          this.regex = null;
          this.regexFlag = false;
          const svg = d3.select('.svgclass');
          svg.selectAll('*').remove();
        }
      },
    },
  },
  methods: {
    /**
     * 줌 설정
     * @author leesy918
     * @param  {[type]} zoomType [description]
     * @return {[type]}          [description]
     */
    onZoom(zoomType) {
      const svg = d3.select('.svgclass');
      if (!isNil(this.zoomHandler)) {
        if (zoomType === 'zoomIn') {
          svg.transition().call(this.zoomHandler.scaleBy, 1.2);
        } else if (zoomType === 'zoomOut') {
          svg.transition().call(this.zoomHandler.scaleBy, 0.8);
        } else if (zoomType === 'zoomInit') {
          if (!isNil(this.zoomHandler)) {
            this.zoomHandler.transform(svg, d3.zoomIdentity);
          }
          svg.selectAll('*').remove();
          this.loadData();
        }
      }
    },
    /**
     * 키워드맵 초기화
     * @author leesy918
     */
    chartReset() {
      this.wordChartData = [];
      this.zoom = {
        x: 0,
        y: 0,
        k: 1,
      };
      const svg = d3.select('.svgclass');
      if (!isNil(this.g)) {
        this.zoomHandler = d3.zoom().scaleExtent([0.5, 4]).on('zoom', () => {
          this.g.attr('transform', `translate(${this.zoom.x},${this.zoom.y})scale(${this.zoom.k})`);
        });
        this.zoomHandler.transform(svg, d3.zoomIdentity);
      }
      svg.selectAll('*').remove();
      if (!isNil(this.selectedNode.type)) {
        this.loadData();
      }
    },
    /**
     * 저장소 선택 시 파라미터 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    getIndexParams() {
      const params = { type: this.selectedNode.type, dataindexId: this.selectedNode.dataindexId };
      return params;
    },
    /**
     * 필터 선택 시 파라미터 설정
     * @author leesy918
     * @return {[type]} [description]
     */
    getFilterParams() {
      const params = { type: this.selectedNode.type, customFilterId: this.selectedNode.customFilterId };
      return params;
    },
    /**
     * 트리메뉴 선택에 따른 파라미터 작성 함수
     * @author leesy918
     */
    setParameter() {
      let params;
      if (this.selectedNode.type === 'dataindex') {
        params = this.getIndexParams();
      } else if (this.selectedNode.type === 'filter') {
        params = this.getFilterParams();
      } else if (this.selectedNode.type === 'group') {
        params = {
          type: 'group',
          filterGroupId: this.selectedNode.filterGroupId,
        };
      } else {
        params = {
          type: 'root',
        };
      }
      params = {
        ...params,
        start: 0,
      };

      return params;
    },
    /**
      * 키워드맵 데이터 조회
      * @author leesy918
      * @return {[type]} [description]
      */
    loadData() {
      const params = this.setParameter();
      params.limit = 2000;
      const date = new Date(this.timeOption.selectStep);
      params.endDateTime = this.timeOption.selectStep;
      params.startDateTime = new Date(date.getTime() - this.timeOption.interval).getTime();
      if (!isEmpty(this.search)) {
        const item = {
          field: 'originMessage',
          value: this.search,
          operator: 'AND',
          regex: 'N',
        };
        this.queryList = [item];
        params.queryList = this.queryList;
      }

      this.loading = true;
      LmsLogAPI.getWordChart(params).then((response) => {
        if (response.data.success) {
          this.wordChartData = response.data.data;
          this.$nextTick(() => {
            this.creatChartData();
          });
        }
      }).catch((e) => {
        this.$message(msgUtil.getResultMsgData(msgUtil.action.VIEW, '로그 데이터', false));
        throw new Error(e);
      }).finally(() => {
        this.loading = false;
      });
    },
    flattern(data) {
      const nodes = [];
      data.size = this.recurse(data, nodes);
      return nodes;
    },
    recurse(node, nodes) {
      if (node.children) node.size = node.children.reduce((p, v) => p + this.recurse(v), 0);
      nodes.push(node);
      return node.size;
    },
    /**
      * 차트 생성
      * @author leesy918
      * @return {[type]} [description]
      */
    creatChartData() {
      const nodes = [];
      const links = [];
      // node & link 데이터 설정
      forEach(this.wordChartData, (item) => {
        if (this.regexFlag) {
          const pattern = new RegExp(this.regex);
          if (pattern.test(item.key)) {
            let searchFlag = true;

            if (!isEmpty(this.search)) {
              searchFlag = false;
              if (item.label.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) {
                searchFlag = true;
              }
              const groupList = item.group;
              if (!isNil(groupList)) {
                groupList.forEach((group) => {
                  if (group.toLowerCase().indexOf(this.search.toLowerCase()) >= 0) {
                    searchFlag = true;
                  }
                });
              }
            }
            if (searchFlag) {
              this.insertNodeAndLink(nodes, links, item);
            }
          }
        }
      });
      this.chartData = {
        nodes,
        links,
      };
      this.$emit('wordCount', this.wordChartData, this.checkGroupFlag);
      this.updateChart();
    },
    /**
     * 키워드맵의 노드와 링크 데이터를 만든다
     * @author leesy918
     * @param  {[type]} nodes [description]
     * @param  {[type]} links [description]
     * @param  {[type]} item  [description]
     * @return {[type]}       [description]
     */
    insertNodeAndLink(nodes, links, item) {
      const checkItem = {
        id: item.id,
        label: item.label,
        size: item.size,
        key: item.key,
        tooltip: `${item.keyLabel}  :  ${item.label}`,
      };
      nodes.push(checkItem);

      // 그룹 노드가 필요한 이유 : 링크 생성을 위해
      const nodeGroup = item.group;
      nodeGroup.forEach((groupItem) => {
        const checkNode = nodes.find((node) => groupItem === node.id);
        if (!isNil(checkNode)) {
          const link = {
            source: item.id,
            target: groupItem,
          };
          if (!(link.source === link.target)) {
            links.push(link);
          }
        }
      });
    },
    /**
     * 키워드맵 작성 함수
     * @author leesy918
     * @return {[type]} [description]
     */
    updateChart() {
      // 그려줄 차트 설정
      const svg = d3.select('.svgclass');
      const color = d3.scaleOrdinal(d3.schemeCategory10);
      const svgWidth = svg.style('width');
      let width = Number(svgWidth.substring(0, svgWidth.length - 2));
      const svgHeight = svg.style('height');
      let height = Number(svgHeight.substring(0, svgHeight.length - 2));
      const tooltip = this.svgToolTip;
      // zoom 초기화
      this.zoom = {
        x: 0,
        y: 0,
        k: 1,
      };
      // svg 내용을 초기화 해준다
      svg.selectAll('*').remove();
      // svg 등록
      if (!isNil(this.zoomHandler)) {
        this.zoomHandler.transform(svg, d3.zoomIdentity);
      }
      if (width <= 10 && height <= 10) {
        width = window.innerWidth - (window.innerWidth / 5);
        height = window.innerHeight - (window.innerHeight / 5);
      }
      const graph = this.chartData;
      const label = {
        nodes: [],
        links: [],
      };
      const container = svg.append('g');
      // 노드 데이터를 이용한 링크 설정
      graph.nodes.forEach((d, i) => {
        label.nodes.push({ node: d });
        label.nodes.push({ node: d });
        label.links.push({
          source: i * 2,
          target: (i * 2) + 1,
        });
      });
      // 차트 출력 위치, 노드 밀집도, 링크의 휘어짐 정도를 설정한다
      this.graphLayout = d3.forceSimulation(graph.nodes)
        .force('charge', d3.forceManyBody().strength(-2000))
        .force('center', d3.forceCenter(width / 2, height / 2))
        .force('x', d3.forceX(width / 2).strength(1))
        .force('y', d3.forceY(height / 2).strength(1))
        .force('link', d3.forceLink(graph.links).id((d) => d.id).distance(200).strength(1))
        .velocityDecay(0.85)
        .on('tick', () => {
          this.textElements
            .attr('x', (node) => node.x)
            .attr('y', (node) => node.y);
          this.node.call((node) => {
            node.attr('transform', (d) => `translate(${this.fixna(d.x)},${this.fixna(d.y)})`);
          });
          this.link.call((link) => {
            link.attr('x1', (d) => this.fixna(d.source.x))
              .attr('y1', (d) => this.fixna(d.source.y))
              .attr('x2', (d) => this.fixna(d.target.x))
              .attr('y2', (d) => this.fixna(d.target.y));
          });
        });

      this.adjlist = [];
      // 링크 연결 관계 설정
      graph.links.forEach((d) => {
        this.adjlist[`${d.source.index}-${d.target.index}`] = true;
        this.adjlist[`${d.target.index}-${d.source.index}`] = true;
      });
      // 링크 설정
      this.link = container.append('g').attr('class', 'links')
        .selectAll('line')
        .data(graph.links)
        .enter()
        .append('line')
        .attr('stroke', '#aaa')
        .attr('stroke-width', '1px');
      // 라벨 설정
      this.textElements = container.append('g').attr('class', 'text').selectAll('text')
        .data(graph.nodes)
        .enter()
        .append('text')
        .text((node) => node.label)
        .attr('font-size', 11)
        .attr('dx', (d) => {
          if (d.size < 100) {
            return 12;
          } else if (d.size < 500) {
            return 15;
          } else if (d.size < 1000) {
            return 18;
          }
          return 23;
        })
        .attr('dy', 4);

      // 노드 설정
      this.node = container.append('g').attr('class', 'nodes')
        .selectAll('g')
        .data(graph.nodes)
        .enter()
        .append('circle')
        .attr('r', (d) => {
          if (d.size < 100) {
            return 5;
          } else if (d.size < 500) {
            return 10;
          } else if (d.size < 1000) {
            return 15;
          }
          return 20;
        })
        .attr('fill', (d) => color(d.key));

      // 줌 초기화
      this.zoomHandler = d3.zoom()
        .scaleExtent([0.1, 4])
        .on('zoom', () => { container.attr('transform', d3.event.transform); });
      // svg에 줌 핸들러 등록
      svg.call(this.zoomHandler);
      // 노드 드래그 이벤트 등록
      this.node.call(
        d3.drag()
          .on('start', (d) => {
            d3.event.sourceEvent.stopPropagation();
            if (!d3.event.active) this.graphLayout.alphaTarget(0.3).restart();
            d.fx = d.x;
            d.fy = d.y;
          })
          .on('drag', (d) => {
            d.fx = d3.event.x;
            d.fy = d3.event.y;
          })
          .on('end', (d) => {
            if (!d3.event.active) this.graphLayout.alphaTarget(0);
            d.fx = null;
            d.fy = null;
          }),
      );
      // 노드 마우스 오버 이벤트 등록
      this.node.on('mouseover', (d) => {
        if (d.tooltip) {
          tooltip.transition().duration(200).style('opacity', 0.9);
          tooltip.html(d.tooltip).style('left', `${d3.event.layerX + 15}px`).style('top', `${d3.event.layerY - 15}px`);
        }
        const index = d3.select(d3.event.target).datum().index;
        this.node.style('opacity', (o) => (this.neigh(index, o.index) ? 1 : 0.1));
        this.textElements.attr('display', (o) => (this.neigh(index, o.index) ? 'block' : 'none'));
        this.link.style('opacity', (o) => (o.source.index === index || o.target.index === index ? 1 : 0.1));
      }).on('mouseout', (d) => {
        if (d.tooltip) {
          tooltip.transition()
            .duration(500)
            .style('opacity', 0);
        }
        this.textElements.attr('display', 'block');
        this.node.style('opacity', 1);
        this.link.style('opacity', 1);
      }).on('mousemove', (d) => {
        tooltip.html(d.tooltip).style('left', `${d3.event.layerX + 15}px`).style('top', `${d3.event.layerY - 15}px`);
      });
    },
    /**
     * 키워드 맵 이어진 노드 탐색
     * @author leesy918
     * @param  {[type]} a [description]
     * @param  {[type]} b [description]
     * @return {[type]}   [description]
     */
    neigh(a, b) {
      return a === b || this.adjlist[`${a}-${b}`];
    },
    /**
     * 링크 설정 함수
     * @author leesy918
     * @param  {[type]} x [description]
     * @return {[type]}   [description]
     */
    fixna(x) {
      if (isFinite(x)) return x;
      return 0;
    },
    /**
     * 키워드맵 안쪽 검색창 검색 시 작동 함수 서버로 해당 단어가 포함된 데이터를 요청한다
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    searchWord(data) {
      this.search = data;
      this.creatChartData();
    },
    /**
     * 연관 단어 발생 테이블 마우스 오버 이벤트
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    getHoverWord(data) {
      const index = this.chartData.nodes.find((node) => node.id === data.id);
      if (!isNil(index)) {
        this.node.style('opacity', (o) => (this.neigh(index.index, o.index) ? 1 : 0.1));
        this.textElements.attr('display', (o) => (this.neigh(index.index, o.index) ? 'block' : 'none'));
        this.link.style('opacity', (o) => (o.source.index === index.index || o.target.index === index.index ? 1 : 0.1));
      }
    },
    /**
     * 연관 단어 발생 테이블 마우스 아웃 이벤트
     * @author leesy918
     * @return {[type]} [description]
     */
    clearWord() {
      this.textElements.attr('display', 'block');
      this.node.style('opacity', 1);
      this.link.style('opacity', 1);
    },
    /**
     * 필드 그룹 체크 이벤트
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    groupCheck(data) {
      this.checkGroupFlag = !isEmpty(data);
      if (isEmpty(data)) {
        this.regex = null;
        this.regexFlag = false;
      } else {
        this.regexFlag = true;
        this.regex = '(';
        data.forEach((item, index) => {
          if (data.length - 1 > index) {
            this.regex += `${item.fieldId}|`;
          } else {
            this.regex += `${item.fieldId})`;
          }
        });
      }
      this.creatChartData();
    },
    /**
     * 연관 단어 발생 테이블 row  클릭 이벤트
     * @author leesy918
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    wordClick(data) {
      this.selectNode = data;
      this.$refs.keywordPopup.open();
    },
    /**
     * 시간 범위 선택 차트 이벤트
     * @author leesy918
     * @return {[type]} [description]
     */
    dragTimeRangeChart() {
      this.checkGroupFlag = false;
      this.chartReset();
    },
  },
};
</script>

<style lang="scss">
.logWordChart-wrapper {
  height: 100%;
  background: #FFF;
  .wordChart-node {
    stroke: #fff;
    stroke-width: 1.5px;
  }
  .keywordPopOver {
    z-index: 1;
  }
  .wordChart-link {
    fill: none;
    stroke: #ccc;
  }
  .treeButton {
    position: absolute;
    top: 40px;
    left: 40px;
  }

  .rangeChart svg line.track {
      stroke-opacity: 0.4;
      stroke: #E4E7ED;
      stroke-width: 10px;
  }
  .rangeChart svg line.track-inset {
      stroke: #E4E7ED;
      stroke-width: 8px;
  }
  .rangeChart svg line.track-overlay {
      stroke: #E4E7ED;
      stroke-width: 40px;
      stroke-opacity: 0;
      cursor: pointer;
  }
  .rangeChart svg .handle {
      fill: #FFF;
      stroke: #409EFF;
  }
  .rangeChart svg line.track-overlay, #chart svg line.track, #chart svg line.track-inset {
      stroke-linecap: round;
  }
  .keywordSearchInput {
    position: absolute;
    z-index: 1;
    top: 40px;
    right: 355px;
    width: 210px;
  }
  .render .tooltip {
  position: absolute;
  padding: 8px;
  text-align: left;
  background: rgba(0, 0, 0, .87);
  color: #fff;
  border: 0px;
  border-radius: 8px;
  pointer-events: none;
  }
  .render .tooltip hr {
    padding: 0;
    margin: 8px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/log-analysis/KeywordMap/LogKeywordMap.vue